import { ProductByBarcodeQuery } from '@epicuro-next/data/product';
import { EntityState } from '@ngrx/entity';
import {
  BasketAccountDelivery,
  BasketManagerInfo,
} from 'graphql-api/baskets-api-interfaces';
import { OrderType } from 'graphql-api/gql-api-interfaces';

import { SCANNER_FEATURE_KEY, SCANN_TO_BASKET_FEATURE_KEY } from './constants';

export enum ScannerStatus {
  SETUP = 'setup',
  SEARCHING = 'searching',
  ADDING_TO_LIST = 'adding-to-list',
  ADDED_TO_LIST = 'added-to-list',
  ADDING_TO_BASKET = 'adding-to-basket',
  ADDED_TO_BASKET = 'added-to-basket',
  NOT_FOUND = 'error-not-found',
  ERROR_ADD_LIST = 'error-list',
  ERROR_ADD_LIST_NOT_MARKETABLE = 'error-list-not-marketable',
  ERROR_ADD_BASKET = 'error-basket',
  ERROR_ADD_BASKET_NOT_SELLABLE = 'error-basket-not-sellable',
  ERROR_ADD_BASKET_LOCKED = 'error-basket-locked',
  ERROR_ADD_BASKET_NO_SHOP = 'error-basket-no-shop',
  ERROR_ADD_BASKET_ALREADY_IN = 'error-basket-already-in',
  ERROR_ADD_BASKET_NOT_AVAILABLE = 'error-basket-not-available',
  DUPED = 'error-duped',
  TARGET_NOT_SELECTED = 'error-no-target',
}

export type ProductByBarcode = NonNullable<
  ProductByBarcodeQuery['productByBarcode']
>;

interface ScanTargetBase<T extends 'List' | 'Basket'> {
  type: T;
}

export interface ScanTargetList {
  id?: string;
  name: string;
}
export interface ListTarget extends ScanTargetBase<'List'> {
  list: ScanTargetList;
}
export type BasketTarget = ScanTargetBase<'Basket'>;

export interface BarcodeProcessResult {
  barcode: string;
  product?: ProductByBarcode;
  target?: ScanTarget;
  added: boolean;
}
export type ScanTarget = ListTarget | BasketTarget;

export type ScannerBasket = Pick<
  BasketManagerInfo,
  'basketId' | 'orderReferenceNumber'
>;
export type ScannerShop = Pick<
  BasketAccountDelivery,
  'accountId' | 'addressId'
>;

export interface UpdateBasketItemParams {
  requestedDate: string;
  orderType: OrderType;
  inventoryId: string;
}

export interface ScannedBasketProduct
  extends ProductByBarcode,
    UpdateBasketItemParams {
  quantity: number;
  basketItemIds?: string[];
}

export interface ScantoBasketState extends EntityState<ScannedBasketProduct> {
  updatingScannedProductIdMap: { [key: string]: boolean };
}

export interface ScannerState {
  status: {
    description: ScannerStatus;
    barcode?: string;
  };
  barcodeReadingResults: BarcodeProcessResult[];
  currentBarcode?: string;
  loadingProduct: boolean;
  target?: ScanTarget;
}

export interface State {
  [SCANNER_FEATURE_KEY]: ScannerState;
  [SCANN_TO_BASKET_FEATURE_KEY]: ScantoBasketState;
}
